import { render, staticRenderFns } from "./Recruits.vue?vue&type=template&id=333028ce&scoped=true&"
import script from "./Recruits.vue?vue&type=script&lang=js&"
export * from "./Recruits.vue?vue&type=script&lang=js&"
import style0 from "./Recruits.vue?vue&type=style&index=0&id=333028ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333028ce",
  null
  
)

export default component.exports